(function () {
	'use strict';

	angular.module('app.setup')
		.controller('pqByCostCtrl', pqByCostCtrl);

	pqByCostCtrl.$inject = ['$rootScope', '$scope', 'leanFilterService', '$timeout', 'pqByCostService',
		'$state', '$location', 'redirectParamsService', 'storeService', 'navigationService', 'tableService', '$experiments'];

	function pqByCostCtrl($rootScope, $scope, leanFilterService, $timeout, pqByCostService,
			$state, $location, redirectParamsService, storeService, navigationService, tableService, $experiments) {
		var vm = this;
		var unsubscribe;
		var reportSettingsName = 'pq-analysis/pq-by-cost';
		var setFirstView = false;
		$scope.filterService = leanFilterService;

		//Set correct navigation highlighting
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		$scope.hideExcel = true;
		$scope.emptyHeader = "We couldn't find any results.";
		$scope.emptySuggestion = '';
		$scope.emptyLinkText = '';
		$scope.itemCount = 50;

		$scope.doDaysOfCoverage = false;

		$scope.metricsToShow = ['Cumulative Percentage', 'Days of Coverage'];
		$scope.metricToShow = 'Cumulative Percentage';

		$scope.metricToShowClick = metricToShowClick;
		$scope.updateItemCount = updateItemCount;

		var extraParams = [{}];
		var isSupplierPortal = (globalConfig.user.role === 'Supplier');
		var defaultFilters = isSupplierPortal 
			? [{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true }]
			: [{
				'id': 'factory',
				'values': [globalConfig.factory.id],
				'isMandatory': true
			},{
				'id': 'itemGroupNdx',
				'values': [$scope.filterService.leanDnaAllSelected]
			},
			{
				'id': 'supplierNdx',
				'values': [$scope.filterService.leanDnaAllSelected]
			},
			{
				'id': 'buyerCode',
				'values': [$scope.filterService.leanDnaAllSelected]
			}];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			extraParams: extraParams,
			waitForFilters: true,
			defaultFilters: defaultFilters,
			showExcel: false,
			hideSearch: true
		};

		vm.getData = getData;
		vm.getMeta = getMeta;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = 'Daily throughput cost';
		
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = 'Daily throughput cost';
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('destroy', function() {
			if (unsubscribe) unsubscribe();
		});
		
		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function getMeta() {
			return meta;
		}

		function getData() {
			pqByCostService.getChartData($scope.filterService, 1000).then(function (data) {
				if (!reportSettingsId && !setFirstView) {
					var firstViewObj = {
						'viewType': $state.current.data.viewType
					};
					navigationService.setFirstView(firstViewObj, reportSettingsName);
					setFirstView = true;
				}
				$scope.loading = false;
				$scope.initialLoad = false;
				if (data === '') {
					$scope.empty = true;
				} else {
					$scope.empty = false;
					$scope.rawData = data;
					$rootScope.$emit('pqByCostDataReady');
				}
			});
		}

		function metricToShowClick(selected) {
			var changed = false;
			if (selected !== $scope.metricToShow) {
				changed = true;
			}
			$scope.doDaysOfCoverage = (selected === 'Days of Coverage');
			$scope.metricToShow = selected;
			if (changed) {
				$rootScope.$emit('pqByCostDataReady');
			}
		}

		function updateItemCount() {
			if ($scope.itemCount === null || typeof $scope.itemCount === 'undefined')
				return;
			$rootScope.$emit('pqByCostDataReady', {'itemCountUpdte': true});
		}

		function init() {
			$scope.filterService.clearFilters();
			$scope.initialLoad = true;
			$scope.filterService.useFactoryFilter = true;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;
			if (!isSupplierPortal) {
				$scope.filterService.setMasterFilterList([
					$scope.filterService.filterDefinitions['Item Group'],
					$scope.filterService.filterDefinitions['Supplier'],
					$scope.filterService.filterDefinitions['Buyer'],
					$scope.filterService.filterDefinitions['Planner']
				]);
			}
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
			$scope.filterService.setResetReportSettingsSettings(reportSettingsName);

			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}

		init();
	}
})();
